import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  container: {
    color: '#1C2541',
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(4),
  },
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
  },
  headerText: {
    fontSize: theme.spacing(3),
    fontWeight: 'bold',
  },
  statsContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
}));
